import { Store } from 'src/store/index';

const getFirstBundledProductId = (store: Store) => store.productBundle.selectedProducts[0]?.productId || 0;

export default getFirstBundledProductId;
